import React from 'react';

import { EtatDto } from 'lib_api/lib/api/gen';

import Table from 'components/WrappedComponents/Table/Table';
import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { useDashboardSearchWithSort } from 'hooks/search/useDashboardSearchWithSort';
import { DEFAULT_PAGE_SIZE_OPTIONS } from 'utils/global';

import DashboardHeader from './DashboardHeader/DashboardHeader';
import CellDetailsAndActions from './CellDetailsAndActions';
import { EtatSort } from './types';
import { useSearchEtat } from './utils';

function buildColumns(
  refreshDashboard: () => void,
): ColumnProps<EtatDto, EtatSort>[] {
  return [
    {
      title: 'Etat',
      buildCellContent: data => data.etat,
      sortedField: 'ETAT',
    },
    {
      title: 'Détails',
      buildCellContent: data => data.detail,
    },
    {
      title: 'Libellé',
      buildCellContent: data => data.libelleCourt,
    },
    {
      title: '',
      buildCellContent: data => (
        <CellDetailsAndActions
          etat={data}
          refreshDashboard={refreshDashboard}
        />
      ),
    },
  ];
}

function DashboardEtat(): React.ReactElement {
  const {
    fetchData,
    pagination,
    setPagination,
    filter,
    setFilter,
    sort,
    setSort,
    refreshDashboard,
  } = useDashboardSearchWithSort(
    useSearchEtat,
    {
      valid: true,
    },
    {
      ETAT: true,
    },
    'paginationAdministrationEtats',
  );
  return (
    <div className="table-container">
      <Table
        columns={buildColumns(refreshDashboard)}
        fetchData={fetchData}
        header={fetchedData => (
          <DashboardHeader
            totalCount={fetchedData?.total || 0}
            refreshDashboard={refreshDashboard}
            filter={filter}
            setFilter={setFilter}
          />
        )}
        buildItemKey={(item): string => item.id}
        filter={filter}
        setFilter={setFilter}
        pageSizeOptions={DEFAULT_PAGE_SIZE_OPTIONS}
        pagination={pagination}
        setPagination={setPagination}
        sort={sort}
        setSort={setSort}
      />
    </div>
  );
}

export default DashboardEtat;
